const Currency = ({ value }) => {
    return `$${value?.toFixed(2)}`;
};

export default Currency;